<div class="row wrapper border-bottom white-bg page-heading" *ngIf="!embedded">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a [routerLink]="['/fire-foresight/admin']">Fire Foresight Admin</a>
      </li>
      <li class="breadcrumb-item">
        <a>Camera Configs</a>
      </li>
    </ol>
  </div>
</div>

<!-- Add Camera Config Modal -->
<div class="modal fade" bsModal #addConfigModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">ADD CAMERA CONFIG</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="addConfigModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Site <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <select [ngModel]="newSiteId" (ngModelChange)="onNewSiteChange($event)"
                        (blur)="markNewFieldTouched('siteId')"
                        class="form-control"
                        [class.is-valid]="newTouched.siteId && newSiteId"
                        [class.is-invalid]="newTouched.siteId && !newSiteId">
                  <option [ngValue]="null">-- Select Site --</option>
                  <option *ngFor="let site of sites" [ngValue]="site.siteId">{{site.name}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Connection Type <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="newConfigType" id="newConfigTypeMqtt" value="Mqtt"
                         [ngModel]="newConfigType" (ngModelChange)="onNewConfigTypeChange($event)"/>
                  <label class="form-check-label" for="newConfigTypeMqtt">MQTT</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="newConfigType" id="newConfigTypeAzure" value="AzureIotHub"
                         [ngModel]="newConfigType" (ngModelChange)="onNewConfigTypeChange($event)"/>
                  <label class="form-check-label" for="newConfigTypeAzure">Azure IoT Hub</label>
                </div>
              </div>
            </div>
          </div>
          
          <ng-container *ngIf="newConfigType === 'Mqtt'">
            <!-- Connection details are now filled in asynchronously by the backend provisioning
                 service after create - only the Client Id is required up front. Fields below are
                 kept (commented out, not deleted) in case manual entry at create time is restored.
            <div class="col-sm-12">
              <div class="form-group input-group-sm">
                <label>Azure Blob URL <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="newMqttConfig.azureBlobUrl" (blur)="markNewFieldTouched('azureBlobUrl')"
                         class="form-control" [class.is-valid]="newTouched.azureBlobUrl && newMqttConfig.azureBlobUrl"
                         [class.is-invalid]="newTouched.azureBlobUrl && !newMqttConfig.azureBlobUrl" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group input-group-sm">
                <label>Azure Blob SAS Token <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="password" [(ngModel)]="newMqttConfig.azureBlobSasToken" (blur)="markNewFieldTouched('azureBlobSasToken')"
                         class="form-control" [class.is-valid]="newTouched.azureBlobSasToken && newMqttConfig.azureBlobSasToken"
                         [class.is-invalid]="newTouched.azureBlobSasToken && !newMqttConfig.azureBlobSasToken" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Camera Serial [Set By Camera]</label>
                <div class="input-group m-b">
                  <input type="text" class="form-control" [(ngModel)]="newMqttConfig.cameraSerial"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Broker URL <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="newMqttConfig.mqttBrokerUrl" (blur)="markNewFieldTouched('mqttBrokerUrl')"
                         class="form-control" [class.is-valid]="newTouched.mqttBrokerUrl && newMqttConfig.mqttBrokerUrl"
                         [class.is-invalid]="newTouched.mqttBrokerUrl && !newMqttConfig.mqttBrokerUrl" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Broker Port <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="number" [(ngModel)]="newMqttConfig.mqttBrokerPort" (blur)="markNewFieldTouched('mqttBrokerPort')"
                         class="form-control" [class.is-valid]="newTouched.mqttBrokerPort && newMqttConfig.mqttBrokerPort"
                         [class.is-invalid]="newTouched.mqttBrokerPort && !newMqttConfig.mqttBrokerPort" required/>
                </div>
              </div>
            </div>
            -->
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Client Id <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="newMqttConfig.mqttClientId" (blur)="markNewFieldTouched('mqttClientId')"
                         (ngModelChange)="onNewClientIdChange($event)" [readonly]="!newIdManualEdit"
                         class="form-control" [class.text-muted]="!newIdManualEdit"
                         [class.is-valid]="newTouched.mqttClientId && newMqttConfig.mqttClientId"
                         [class.is-invalid]="newTouched.mqttClientId && !newMqttConfig.mqttClientId" required/>
                </div>
                <div class="form-check mt-1">
                  <input class="form-check-input" type="checkbox" id="newIdManualEditMqtt"
                         [ngModel]="newIdManualEdit" (ngModelChange)="onNewIdManualEditChange($event)"/>
                  <label class="form-check-label" for="newIdManualEditMqtt">Edit manually (defaults to the site's URI)</label>
                </div>
              </div>
            </div>
            <!--
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Username <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="newMqttConfig.mqttUsername" (blur)="markNewFieldTouched('mqttUsername')"
                         class="form-control" [class.is-valid]="newTouched.mqttUsername && newMqttConfig.mqttUsername"
                         [class.is-invalid]="newTouched.mqttUsername && !newMqttConfig.mqttUsername" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Password <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="password" [(ngModel)]="newMqttConfig.mqttPassword" (blur)="markNewFieldTouched('mqttPassword')"
                         class="form-control" [class.is-valid]="newTouched.mqttPassword && newMqttConfig.mqttPassword"
                         [class.is-invalid]="newTouched.mqttPassword && !newMqttConfig.mqttPassword" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group input-group-sm pb-2">
                <label>Use TLS</label>
                <div class="input-group m-b">
                  <input type="checkbox" [(ngModel)]="newMqttConfig.useTls" class="form-control-checkbox"/>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group input-group-sm">
                <label>Image Topic <small class="text-muted">(auto-generated)</small></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="newMqttConfig.mqttTopicImage"
                         class="form-control text-muted" readonly disabled tabindex="-1"/>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group input-group-sm">
                <label>Command Topic <small class="text-muted">(auto-generated)</small></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="newMqttConfig.mqttTopicCommand"
                         class="form-control text-muted" readonly disabled tabindex="-1"/>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group input-group-sm">
                <label>Telemetry Topic <small class="text-muted">(auto-generated)</small></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="newMqttConfig.mqttTopicTelemetry"
                         class="form-control text-muted" readonly disabled tabindex="-1"/>
                </div>
              </div>
            </div>
            -->
          </ng-container>

          <ng-container *ngIf="newConfigType === 'AzureIotHub'">
            <!-- Connection details are now filled in asynchronously by the backend provisioning
                 service after create - only the Hub Device Id is required up front. Fields below
                 are kept (commented out, not deleted) in case manual entry at create time is restored.
            <div class="col-sm-12">
              <div class="form-group input-group-sm">
                <label>Azure Blob URL <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="newAzureConfig.azureBlobUrl" (blur)="markNewFieldTouched('azureBlobUrl')"
                         class="form-control" [class.is-valid]="newTouched.azureBlobUrl && newAzureConfig.azureBlobUrl"
                         [class.is-invalid]="newTouched.azureBlobUrl && !newAzureConfig.azureBlobUrl" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group input-group-sm">
                <label>Azure Blob SAS Token <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="password" [(ngModel)]="newAzureConfig.azureBlobSasToken" (blur)="markNewFieldTouched('azureBlobSasToken')"
                         class="form-control" [class.is-valid]="newTouched.azureBlobSasToken && newAzureConfig.azureBlobSasToken"
                         [class.is-invalid]="newTouched.azureBlobSasToken && !newAzureConfig.azureBlobSasToken" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Camera Serial [Set By Camera]</label>
                <div class="input-group m-b">
                  <input type="text" class="form-control" [(ngModel)]="newAzureConfig.cameraSerial"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Hub Host Name <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="newAzureConfig.azureHubHostName" (blur)="markNewFieldTouched('azureHubHostName')"
                         class="form-control" [class.is-valid]="newTouched.azureHubHostName && newAzureConfig.azureHubHostName"
                         [class.is-invalid]="newTouched.azureHubHostName && !newAzureConfig.azureHubHostName" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Hub SAS Token <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="password" [(ngModel)]="newAzureConfig.azureHubSasToken" (blur)="markNewFieldTouched('azureHubSasToken')"
                         class="form-control" [class.is-valid]="newTouched.azureHubSasToken && newAzureConfig.azureHubSasToken"
                         [class.is-invalid]="newTouched.azureHubSasToken && !newAzureConfig.azureHubSasToken" required/>
                </div>
              </div>
            </div>
            -->
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Hub Device Id <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="newAzureConfig.azureHubDeviceId" (blur)="markNewFieldTouched('azureHubDeviceId')"
                         [readonly]="!newIdManualEdit" class="form-control" [class.text-muted]="!newIdManualEdit"
                         [class.is-valid]="newTouched.azureHubDeviceId && newAzureConfig.azureHubDeviceId"
                         [class.is-invalid]="newTouched.azureHubDeviceId && !newAzureConfig.azureHubDeviceId" required/>
                </div>
                <div class="form-check mt-1">
                  <input class="form-check-input" type="checkbox" id="newIdManualEditAzure"
                         [ngModel]="newIdManualEdit" (ngModelChange)="onNewIdManualEditChange($event)"/>
                  <label class="form-check-label" for="newIdManualEditAzure">Edit manually (defaults to the site's URI)</label>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="addConfigModal.hide()" class="btn btn-white">Cancel</button>
        <button (click)="saveNewConfig();addConfigModal.hide()" class="btn btn-white" [disabled]="!isNewConfigValid()">Add</button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Camera Config Modal -->
<div class="modal fade" bsModal #editConfigModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">UPDATE CAMERA CONFIG</h5> <span class="pt-2">{{editConfig.id}}</span>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="editConfigModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Site <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <select [(ngModel)]="editSiteId"
                        (blur)="markEditFieldTouched('siteId')"
                        class="form-control"
                        [class.is-valid]="editTouched.siteId && editSiteId"
                        [class.is-invalid]="editTouched.siteId && !editSiteId">
                  <option [ngValue]="null">-- Select Site --</option>
                  <option *ngFor="let site of sites" [ngValue]="site.siteId">{{site.name}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Connection Type</label>
              <div class="input-group m-b">
                <span class="pt-2 badge bg-info">{{editConfigType === 'Mqtt' ? 'MQTT' : 'Azure IoT Hub'}}</span>
                <span class="ps-2 text-muted small">(fixed at creation)</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Camera Serial [Set By Camera]</label>
              <div class="input-group m-b">
                <input type="text" class="form-control" [(ngModel)]="editConfig.cameraSerial"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Access Key</label>
              <div class="input-group m-b">
                <input type="text" class="form-control" [value]="editConfig.accessKey" readonly disabled/>
              </div>
            </div>
          </div>

          <ng-container *ngIf="editConfigType === 'Mqtt'">
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Broker URL <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="editConfig.mqttBrokerUrl" (blur)="markEditFieldTouched('mqttBrokerUrl')"
                         class="form-control" [class.is-valid]="editTouched.mqttBrokerUrl && editConfig.mqttBrokerUrl"
                         [class.is-invalid]="editTouched.mqttBrokerUrl && !editConfig.mqttBrokerUrl" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Broker Port <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="number" [(ngModel)]="editConfig.mqttBrokerPort" (blur)="markEditFieldTouched('mqttBrokerPort')"
                         class="form-control" [class.is-valid]="editTouched.mqttBrokerPort && editConfig.mqttBrokerPort"
                         [class.is-invalid]="editTouched.mqttBrokerPort && !editConfig.mqttBrokerPort" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Client Id <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="editConfig.mqttClientId" (blur)="markEditFieldTouched('mqttClientId')"
                         (ngModelChange)="onEditClientIdChange($event)"
                         class="form-control" [class.is-valid]="editTouched.mqttClientId && editConfig.mqttClientId"
                         [class.is-invalid]="editTouched.mqttClientId && !editConfig.mqttClientId" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Username <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="editConfig.mqttUsername" (blur)="markEditFieldTouched('mqttUsername')"
                         class="form-control" [class.is-valid]="editTouched.mqttUsername && editConfig.mqttUsername"
                         [class.is-invalid]="editTouched.mqttUsername && !editConfig.mqttUsername" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Password <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="password" [(ngModel)]="editConfig.mqttPassword" (blur)="markEditFieldTouched('mqttPassword')"
                         class="form-control" [class.is-valid]="editTouched.mqttPassword && editConfig.mqttPassword"
                         [class.is-invalid]="editTouched.mqttPassword && !editConfig.mqttPassword" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group input-group-sm pb-2">
                <label>Use TLS</label>
                <div class="input-group m-b">
                  <input type="checkbox" [(ngModel)]="editConfig.useTls" class="form-control-checkbox"/>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group input-group-sm">
                <label>Image Topic <small class="text-muted">(auto-generated)</small></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="editConfig.mqttTopicImage"
                         class="form-control text-muted" readonly disabled tabindex="-1"/>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group input-group-sm">
                <label>Command Topic <small class="text-muted">(auto-generated)</small></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="editConfig.mqttTopicCommand"
                         class="form-control text-muted" readonly disabled tabindex="-1"/>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group input-group-sm">
                <label>Telemetry Topic <small class="text-muted">(auto-generated)</small></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="editConfig.mqttTopicTelemetry"
                         class="form-control text-muted" readonly disabled tabindex="-1"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Azure Blob URL <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="editConfig.azureBlobUrl" (blur)="markEditFieldTouched('azureBlobUrl')"
                         class="form-control" [class.is-valid]="editTouched.azureBlobUrl && editConfig.azureBlobUrl"
                         [class.is-invalid]="editTouched.azureBlobUrl && !editConfig.azureBlobUrl" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Azure Blob SAS Token <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="password" [(ngModel)]="editConfig.azureBlobSasToken" (blur)="markEditFieldTouched('azureBlobSasToken')"
                         class="form-control" [class.is-valid]="editTouched.azureBlobSasToken && editConfig.azureBlobSasToken"
                         [class.is-invalid]="editTouched.azureBlobSasToken && !editConfig.azureBlobSasToken" required/>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="editConfigType === 'AzureIotHub'">
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Hub Host Name <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="editConfig.azureHubHostName" (blur)="markEditFieldTouched('azureHubHostName')"
                         class="form-control" [class.is-valid]="editTouched.azureHubHostName && editConfig.azureHubHostName"
                         [class.is-invalid]="editTouched.azureHubHostName && !editConfig.azureHubHostName" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Hub SAS Token <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="password" [(ngModel)]="editConfig.azureHubSasToken" (blur)="markEditFieldTouched('azureHubSasToken')"
                         class="form-control" [class.is-valid]="editTouched.azureHubSasToken && editConfig.azureHubSasToken"
                         [class.is-invalid]="editTouched.azureHubSasToken && !editConfig.azureHubSasToken" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Hub Device Id <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="editConfig.azureHubDeviceId" (blur)="markEditFieldTouched('azureHubDeviceId')"
                         class="form-control" [class.is-valid]="editTouched.azureHubDeviceId && editConfig.azureHubDeviceId"
                         [class.is-invalid]="editTouched.azureHubDeviceId && !editConfig.azureHubDeviceId" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Azure Blob URL <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="text" [(ngModel)]="editConfig.azureBlobUrl" (blur)="markEditFieldTouched('azureBlobUrl')"
                         class="form-control" [class.is-valid]="editTouched.azureBlobUrl && editConfig.azureBlobUrl"
                         [class.is-invalid]="editTouched.azureBlobUrl && !editConfig.azureBlobUrl" required/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Azure Blob SAS Token <span class="text-danger">*</span></label>
                <div class="input-group m-b">
                  <input type="password" [(ngModel)]="editConfig.azureBlobSasToken" (blur)="markEditFieldTouched('azureBlobSasToken')"
                         class="form-control" [class.is-valid]="editTouched.azureBlobSasToken && editConfig.azureBlobSasToken"
                         [class.is-invalid]="editTouched.azureBlobSasToken && !editConfig.azureBlobSasToken" required/>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="editConfigModal.hide()" class="btn btn-white">Cancel</button>
        <button (click)="saveEditConfig();editConfigModal.hide()" class="btn btn-white" [disabled]="!isEditConfigValid()">Save</button>
      </div>
    </div>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight" id="camera-configs">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-2 bg-emphasis bg-opacity-25">
        <div class="card-header d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
          <span class="flex-grow-1">Camera Configs</span>
          <div class="me-3">
            <label class="me-2">Connection Type</label>
            <select [(ngModel)]="connectionModeFilter" (ngModelChange)="onFilterChange()" class="form-control d-inline-block" style="width: auto;">
              <option [ngValue]="null">All</option>
              <option [ngValue]="0">MQTT</option>
              <option [ngValue]="1">Azure IoT Hub</option>
            </select>
          </div>
          <button (click)="loadConfigs(page)" class="btn btn-outline-default me-2" [disabled]="loading">
            <i class="fa fa-sync" [class.fa-spin]="loading"></i> Refresh
          </button>
          <button (click)="unfreezeConfigs()" class="btn btn-outline-default me-2">
            <i class="fa fa-unlock"></i> Unfreeze
          </button>
          <button (click)="openAddModal();addConfigModal.show()" class="btn btn-outline-default">Add Camera Config</button>
        </div>
        <div class="card-body">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Site</th>
                <th scope="col">Type</th>
                <th scope="col">Camera Serial</th>
                <th scope="col">Access Created</th>
                <th scope="col">Status</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of configs">
                <td>{{item.id}}</td>
                <td>{{getSiteName(item.fireforesightCameraId)}}</td>
                <td>{{getConfigTypeLabel(item)}}</td>
                <td>{{item.cameraSerial}}</td>
                <td>{{item.accessCreated | date:'short'}}</td>
                <td>
                  <span class="badge" [class.bg-secondary]="isExpired(item)" [class.bg-warning]="!isExpired(item) && isPending(item)"
                        [class.bg-success]="!isExpired(item) && !isPending(item)">
                    {{isExpired(item) ? 'Expired' : (isPending(item) ? 'Pending' : 'Active')}}
                  </span>
                </td>
                <td>
                  <a (click)="openEditModal(item, editConfigModal)" class="btn btn-outline-default"><i class="fa fa-pencil"></i></a>
                  &nbsp;
                  <a *ngIf="!isExpired(item)" (click)="finishConfig(item)" class="btn btn-outline-danger ml-2"><i class="fa fa-lock"></i> Close License</a>
                </td>
              </tr>
              <tr *ngIf="!loading && configs.length === 0">
                <td colspan="7" class="text-center text-muted">No camera configs found.</td>
              </tr>
            </tbody>
          </table>

          <div class="d-flex align-items-center justify-content-between">
            <span>Page {{page}} of {{totalPages}} ({{totalCount}} total)</span>
            <div>
              <button class="btn btn-outline-default" [disabled]="page <= 1" (click)="previousPage()">Previous</button>
              <button class="btn btn-outline-default ms-2" [disabled]="page >= totalPages" (click)="nextPage()">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
